import { forwardRef } from 'react';
import classes from './HTMLSelect.module.css';

function HTMLSelect ( props, parentRef ) {
	const theStart = (props.signupQty>1) ? 0 : 1;
	const theValue = props.signupQty/10;
	let theOptions = [];
	for (var i = theStart; i <= props.limit; i++) {
		theOptions.push(<option key={i} value={i}>{i*10+" total cards"}</option>);
	}

	return (
        <select 
			id={props.id} 
			ref={parentRef} 
			defaultValue={theValue} 
			className={classes.cardSelect}>
			{theOptions}
        </select>
    );
}

export default forwardRef(HTMLSelect);